import { PUB_CONFIGS } from "./lightboxPubData";

export type LightboxPubConfig = {
  pubId: string;
  language: string;
  theme: {
    colors: Record<string, string>;
    bannerImageURLs: Record<string, string>;
  };
};

function buildBannerUrl(filename: string): string {
  if (!filename) return "";
  if (typeof window !== "undefined") {
    return `${window.location.origin}/lightbox/${filename}`;
  }
  return `/lightbox/${filename}`;
}

export function getLightboxConfig(
  pubId: string | undefined,
): LightboxPubConfig {
  const data = (pubId && PUB_CONFIGS[pubId]) || PUB_CONFIGS.st;
  const bannerUrl = buildBannerUrl(data.logo);
  return {
    pubId: data.pubId,
    language: data.language,
    theme: {
      colors: data.colors,
      bannerImageURLs: bannerUrl ? { "banner-url": bannerUrl } : {},
    },
  };
}
